// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import AuthorManager from "../../components/dashboard/AuthorManager";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <AuthorManager />
    </DashboardLayout>
  );
}
